module.exports = __webpack_public_path__ + "img/reportsGrey.25308b21.svg";